export enum TipoDeModalAcoesDocumento {
  COMPARTILHAR = 'compartilhar',
  HISTORICO = 'historico',
}
